import coreAPIInstance from "./coreApiInstance";

export const contentImagesAPIs = {
  generateContentImage: ({ payload }) => coreAPIInstance.post("/api/v1/images.generate", payload),
  listContentImages: ({ payload }) => coreAPIInstance.post("/api/v1/images.list", payload),
  deleteContentImages: ({ payload }) => coreAPIInstance.post("/api/v1/images.delete", payload),
  updateContentImage: ({ payload }) => coreAPIInstance.post("/api/v1/images.update", payload),
};
